import { MDBBtn } from 'mdbreact'
import React from 'react'

const Botones = (props) => <MDBBtn
    color={props?.styles?.color}
    size={props?.styles?.size}
    rounded={props?.styles?.rounded}
    href={props?.styles?.hipervinculo}
    outline={props?.styles?.outline}
    className={`${!props?.styles?.hoverBtn && 'sin-hover'} ${props?.styles?.shadowsBtn && `z-depth-${props?.styles?.shadowsBtn}`}`}
>
    {props?.styles?.textoBoton}
</MDBBtn>


export default Botones